
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parlors/region/[code]/[sigungu]",
      function () {
        return require("private-next-pages/parlors/region/[code]/[sigungu].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parlors/region/[code]/[sigungu]"])
      });
    }
  